import {Injectable} from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from "rxjs";
import {v1URL} from '../../shared/constants/urls.constants';
import {LoginModel} from "../models/login.model";
import {CommonService} from "../../shared/services/common.service";
import {ForgotPasswordModel} from "../models/forgot-password.model";
import {SetPasswordModel} from "../models/set-password.model";
import {GenerateOtpModel} from "../models/generate-otp.model";
import {VerifyOtpModel} from "../models/verify-otp.model";
import {RegisterModel} from "../models/register.model";
import {FetchConsentFormModel} from "../models/fetch-consent-form.model";
import {FetchConsentStatusModel} from "../models/fetch-consent-status.model";
import {ParticipantPhiAndPiiDetailsFormModel} from "../models/participant-phi-and-pii-details-form.model";
import {VerifyUsernameModel} from "../models/verify-username.model";
import {FetchObQuestionsModel} from "../models/fetch-ob-questions.model";
import {QuestionResponse} from "../../../models/question-response";
import {SaveAnswersModel} from "../../page-modules/participants-list/models/save-answers.model";


@Injectable({
  providedIn: 'root',
})

export class AuthenticationService {
  forgotPasswordRequest = new Subject<void>();
  forgotPasswordSuccess = new Subject<void>();
  forgotPasswordFailure = new Subject<void>();
  generateOtpSuccess = new BehaviorSubject<boolean>(false);
  generateOtpFailure = new Subject<void>();

  constructor(private commonServices: CommonService) {
  }

  login(payload: LoginModel['request']): Observable<LoginModel['response']> {
    const urlConfig = v1URL.user.login
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  forgotPassword(payload: ForgotPasswordModel['request']): Observable<ForgotPasswordModel['response']> {
    const urlConfig = v1URL.user.password.forgot
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  setPassword(payload: SetPasswordModel['request']): Observable<SetPasswordModel['response']> {
    const urlConfig = v1URL.user.password.set
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  generateOtp(payload: GenerateOtpModel['request']): Observable<GenerateOtpModel['response']> {
    const urlConfig = v1URL.otp.generate
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  verifyOtp(payload: VerifyOtpModel['request']): Observable<VerifyOtpModel['response']> {
    const urlConfig = v1URL.otp.verify
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  register(payload: RegisterModel['request']): Observable<RegisterModel['response']> {
    const urlConfig = v1URL.user.register
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  logout(): Observable<any> {
    const urlConfig = v1URL.user.logout;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchConsentFormLink(payload: FetchConsentFormModel['request']): Observable<FetchConsentFormModel['response']> {
    const urlConfig = v1URL.user.registration['consent-form-link']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchConsentStatus(): Observable<FetchConsentStatusModel['response']> {
    const urlConfig = v1URL.user.registration['user-consent-mark']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  verifyUsername(payload: VerifyUsernameModel['request']): Observable<VerifyUsernameModel['response']> {
    const urlConfig = v1URL.username.verify
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchObQuestions(payload: FetchObQuestionsModel['request']): Observable<FetchObQuestionsModel['response']> {
    const urlConfig = v1URL.user["ob-questions"]["ob-questions"]
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  saveAnswers(payload?: { responses?: QuestionResponse[] }): Observable<SaveAnswersModel["response"]> {
    const urlConfig = v1URL.user['ob-questions']['save-responses']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

}
